module.exports = __webpack_public_path__ + "static/bastra-18a27306bb365466fc78aa84a0d4efae.png";